export const informCustomEvent = (eventName, data = {}) => {
    console.log(eventName)
    typeof window !== "undefined" && window.gtag("event", eventName)
}